<template>
  <div class="edit-wrap">
    修改密码
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>